import set from "@rill/set";
import rill from "rill";
import { triggerClientConfigMigration } from "../../../middleware/trigger-client-config-migration.js";
import { getExerciseLibrary } from "./exercise-library.controller.js";
import { getRoot } from "./profile.controller.js";
import { startTraining } from "./start-training.controller.js";

const Profile = (app) => {
  app.at(
    "/profile/*",
    rill()
      .use(set("heading", ["Athlete", "Profile"]))
      .setup((app) => {
        app.get("/", triggerClientConfigMigration, getRoot);
      })
      .setup((app) => {
        app.get("/exercise-library", getExerciseLibrary);
      })
      .setup((app) => {
        app.get("/start-training", startTraining);
      })
  );
};

export default Profile;
